<template>
  <div class=header>
    <!-- 全部网吧 -->
    <header-tag
      v-if="titleType==1"
      :title="$PAGE_API.home.children.barManager.children.index.children.allBar.title + ' (' + allBarNumInfo.online + '/' + allBarNumInfo.total + ')'"
    ></header-tag>
    <!-- 离线服务器的网吧 -->
    <header-tag
      v-if="titleType==2"
      :title="$PAGE_API.home.children.barManager.children.index.children.serverOfflineBar.title + ' (' + $store.state.barDetails.serverOfflineBarNum + ')'"
    ></header-tag>
    <!-- 选中的分组 -->
    <header-tag
      v-if="titleType==3"
      :title="selectedBarGroupName+'('+$store.state.user.selectedBarGroupOnline+'/'+$store.state.user.selectedBarGroupTotal+')'"
    ></header-tag>
    <!-- 搜索的网吧 -->
    <header-tag
      v-if="titleType==4"
      :title="$PAGE_API.home.children.barManager.children.index.children.searchBar.title + ' (' + $store.state.barDetails.searchBarNum + ')'"
    ></header-tag>
    <div class=right>
      <plugin-install-tip></plugin-install-tip>
      <a
        href=https://123.weihudashi.com/70/
        target=_blank
      >如何删除网吧ID</a>
      <a
        href=#
        v-if="hasRegisterBar"
        @click.prevent="registerBar"
        class=blue-btn
      >注册网吧ID</a>
      <hover-down>
        <div
          slot=hoverBtn
          class=default-btn
        >
          <span>更多</span>
          <img src="@/assets/img/icon/u231.png" />
        </div>
        <div slot=down>
          <div
            class=drop-row
            @click="barGroupManage"
          >
            <span>网吧分组管理</span>
          </div>
          <!-- <i class=line></i>
                    <div class=drop-row
                        @click="addAllRouterRemote">
                        <span>批量添加路由</span>
                    </div>
                    <div class=drop-row
                        @click="deleteAllRouter">
                        <span>删除全部路由</span>
                    </div> -->
          <i class=line></i>
          <div
            class=drop-row
            @click="receiveBar"
          >
            <span>接收网吧</span>
          </div>
          <div
            class=drop-row
            @click="sendBar"
          >
            <span>转出全部网吧</span>
          </div>
        </div>
      </hover-down>
      <a
        href=#
        @click.prevent="refresh"
        class=default-btn
      >刷新</a>
    </div>
  </div>
</template>

<script>
// 头部tag内容
import HeaderTag from '_c/tagTitle/headerTag'
import PluginInstallTip from '_sc/pluginInstallTip'
// 更多悬浮
import HoverDown from '_c/dropdown/hoverDown'
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  name: 'barHeader',
  components: {
    HeaderTag,
    HoverDown,
    PluginInstallTip
  },
  data() {
    return {
      title: '',
      titleType: 0
    }
  },
  watch: {
    /* eslint-disable */
    '$route'(to, from) {
      this.getTitle(to.fullPath)
    }
  },
  mounted() {
    this.getTitle(this.$route.fullPath)
  },
  computed: {
    ...mapState({
      hasRegisterBar: state => state.user.userInfo.hasRegisterBar,
      selectedBarGroupName: state => state.user.selectedBarGroupName,
    }),
    ...mapGetters({
      'allBarNumInfo': 'user/allBarNumInfo',
      'groupNumInfo': 'user/groupNumInfo'
    })
  },
  methods: {
    ...mapActions([
      'user/actionUpdateBarGroupList'
    ]),
    async getTitle(path) {
      if (path) {
        if (path.indexOf('barAll') > -1) {
          this.titleType = 1
        }
        if (path.indexOf('serverOfflineBar') > -1) {
          this.titleType = 2
        }
        if (path.indexOf('groupBar') > -1) {
          this.titleType = 3
        }
        if (path.indexOf('searchBar') > -1) {
          this.titleType = 4
        }
      }
    },
    async registerBar() {
      let res = await window.$modal.editBarInfo.show({ type: 0 })
      if (res) {
        this.refresh()
      }
    },
    async barGroupManage() {
      let res = await window.$modal.barGroupManageModal.show()
      if (res) {
        this.refresh()
      }
    },
    addAllRouterRemote() {
      this.$emit('addAllRouterRemote')
    },
    deleteAllRouter() {
      this.$emit('deleteAllRouter')
    },
    receiveBar() {
      window.$modal.receiveBarModal.show()
    },
    sendBar() {
      window.$modal.sendBarModal.show({ barIds: null })
    },
    refresh() {
      let l = window.$msg.loading("请稍候...");
      setTimeout(() => {
        l.destroy()();
      }, 300);
      this.$emit('refresh')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "_style/_color.scss";

.header {
  padding-left: 30px;
  // padding-top: 20px;
  text-align: left;
  position: relative;
  z-index: 10;
}
.right {
  float: right;
  padding-right: 20px;
  a {
    margin-left: 6px;
    line-height: normal;
  }
  a:nth-child(1) {
    color: $blue;
  }
  .default-btn {
    line-height: normal;
    text-align: center;
    cursor: pointer;
    img {
      margin-left: 12px;
    }
  }
  .default-btn:hover {
    background-color: #fff;
  }
}
</style>

